import { render, staticRenderFns } from "./dishCheckProcess.vue?vue&type=template&id=2507c53e&scoped=true&"
import script from "./dishCheckProcess.vue?vue&type=script&lang=js&"
export * from "./dishCheckProcess.vue?vue&type=script&lang=js&"
import style0 from "./dishCheckProcess.vue?vue&type=style&index=0&id=2507c53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2507c53e",
  null
  
)

export default component.exports